import { render, staticRenderFns } from "./ios_button.vue?vue&type=template&id=2390a89c&"
import script from "./ios_button.vue?vue&type=script&lang=js&"
export * from "./ios_button.vue?vue&type=script&lang=js&"
import style0 from "./ios_button.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports